import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpRequest, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { Router } from '@angular/router';
import { NotificationService } from '../../service/notification.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncriptDecriptService } from '../../../../services/encriptdecript';


@Injectable()

export class OrganisationService {

  constructor(private http: HttpClient, private router: Router,
    public activeModal: NgbActiveModal,
    private encriptDecriptService:EncriptDecriptService,
    private notificationService: NotificationService) {
  }
  private standardHeaders() {
    return {
      'Content-Type': 'application/json',
      'token': this.encriptDecriptService.getKeyLocalStorage('token'),
    };

  }

  goToLoginPage() {
    this.activeModal.close();    
    this.router.navigate(['/login']);
    sessionStorage.clear();
    localStorage.clear();
    this.notificationService.sessionExpaireNotification();
  }

  gatCountryCallingCode(countryName){
   return  this.http.get('https://restcountries.eu/rest/v2/name/'+countryName+'?fullText=true');
  }


  // to list only on the view use this to ViewList speedups
  getOrganisationViewList(orgId: Number, isActive: boolean): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/viewList',
      { 'organisationId': orgId, 'isActive': isActive },
      {
        headers: this.standardHeaders()
      }).pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getbyOrganisationDataById(organisationId: number, isActive): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/params', { 'organisationId': organisationId, 'isActive': isActive },
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );

  }

  // get organisation Object by ID

  getOrganisationById(organisationId: any): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/params', { 'organisationId': organisationId },
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );;
  }

  // get organisation Object by ID

  // delete organisation method
  pushFileToStorage(file: File, organisation: any): Observable<HttpEvent<{}>> {
    const formdata: FormData = new FormData();
    formdata.append('file', file);
    formdata.append('organisationObject', JSON.stringify(organisation));
    let headers = new HttpHeaders({
      'token': this.encriptDecriptService.getKeyLocalStorage('token')
    });
    const req = new HttpRequest('POST', environment.api_url + '/organisation',
      formdata, { headers: headers, reportProgress: true });
    return this.http.request(req)
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  // to get isActive based organisationlist 11-07-18
  getIsActivebasedOrganisationList(orgId: Number, isActive: boolean): Observable<any> {
    const payload = { 'organisationId': orgId, 'isActive': isActive };
    return this.http.post(environment.api_url + '/organisation/viewList', payload, {
      headers: this.standardHeaders()
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  getOrganisationList(): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/list', {},
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );

  }

  getOrganisationListForBulkUser(): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/list', {},
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { 
            this.activeModal.close();    
            this.router.navigate(['/login']);
            sessionStorage.clear();
            localStorage.clear();
           }
          return _throw(error);
        })
      );

  }

  getChildOrganisationList(OrganisationId): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/childList?OrganisationId=' + OrganisationId, {},
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getChildOrganisationListForBulkUser(OrganisationId): Observable<any> {
    return this.http.post(environment.api_url + '/organisation/childList?OrganisationId=' + OrganisationId, {},
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { 
            this.activeModal.close();    
            this.router.navigate(['/login']);
            sessionStorage.clear();
            localStorage.clear();
           }
          return _throw(error);
        })
      );
  }

  saveOrg(data: any): Observable<any> {
    return this.http.post(environment.api_url + '/organisation', data,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  delete(data) {
    return this.http.post(environment.api_url + '/organisation', data,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  // batch delete for organisation component 23:07:18
  BatchDeleteForOrganisation(organisationIds: any) {
    return this.http.post(environment.api_url + '/organisation/batchDelete', organisationIds,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  /**
   * getPrganisationTree
   */
  public getPrganisationTree(orgId:any): Observable<any> {
    const URL = `${environment.api_url}/organisation/treeStructureList`;
    let headers = new HttpHeaders({
      'token': this.encriptDecriptService.getKeyLocalStorage('token')
    });
    return this.http.post(URL, { organisationId: orgId }, { headers: this.standardHeaders() })
      // .map(
      //   (res: Response) => res['data']
      // );
      .pipe(
        map((response: any) => {
          return response.data;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/organisation/services/organisation.service.ts